import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    value: [],
};

export const banksSlice = createSlice({
    name: "banksSlice",
    initialState,
    reducers: {
        storeBanks: (state, action) => {
            state.value = action.payload;
        },
    },
});

export const { storeBanks } = banksSlice.actions;

export default banksSlice.reducer;
